import React, { useState, useEffect } from "react";

const LeagueModal = ({ league, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
  });

  useEffect(() => {
    if (league) {
      setFormData({
        name: league.name,
      });
    }
  }, [league]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(league ? { ...league, ...formData } : formData);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
      <div className="bg-surface-800 border border-line-strong rounded-lg w-96">
        <h2 className="text-white text-xl mb-4">
          {league ? "Edit League" : "Add League"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-white mb-2">Name</label>
            <input
              type="text"
              className="field"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="bg-surface-600 text-white px-4 py-2 rounded"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-accent text-white px-4 py-2 rounded"
            >
              {league ? "Update" : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeagueModal; 